import React from "react";
import classes from "./ErrorBoundary.module.css";
import { useRouteError } from "react-router-dom";
import BackgroundLayout from "../Components/BackgroundLayout";
import NavbarMobile from "../Components/NavbarMobile";
import Navbar from "../Components/Navbar";
import ErrorCard from "../Components/Drag-Cards/ErrorCard";
import SearchModal from "../Components/SearchModal";
import WatchlistModal from "../Components/WatchlistModal";
import UserRatingsModal from "../Components/UserRatingsModal";
import ProfileModal from "../Components/ProfileModal";
import Drawer from "../Components/Drawer";
import BottomNavbar from "../Components/BottomNavbar";

const ErrorBoundary = () => {
  const error: any = useRouteError();
  console.error(error);
  return (
    <>
      <BackgroundLayout>
        <NavbarMobile />
        <Navbar activeLink={null} />
        <ErrorCard
          error={{
            originalStatus: 400,
            error: error?.message || "Something Went Wrong",
          }}
        />
      </BackgroundLayout>

      <SearchModal />

      <WatchlistModal />
      <UserRatingsModal />
      <ProfileModal />
      <Drawer />
      <BottomNavbar activeLink={null} />
    </>
  );
};

export default ErrorBoundary;
